<template>
  <button :class="[variantCop, giveMeClassDisabled]" @click="click" :type="type">
    <PIcon
      :icon="icon"
      :type="iType"
      :size="iSize"
      :color="iColor"
      v-if="icon !== ''"
      class="icon_PButton"
    ></PIcon>
    <span
      :class="['textButton', classMarginIcon]"
      v-if="!(variant === 'circle' || variant === 'gray-circle')"
    >
      <slot></slot>
    </span>
  </button>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";
import PIcon from "../PIcon/PIcon.vue";

@Component({
  components: {
    PIcon,
  },
})
export class PButton extends Vue {
  @Prop({ required: false, default: "primary" }) variant!:
    | "primary"
    | "secondary"
    | "circle"
    | "gray-circle"
    | "transparent";
  @Prop({ required: false, default: false }) disabled!: boolean;
  @Prop({ required: false, default: "" }) icon!: string;
  @Prop({ required: false, default: "" }) iType!: string;
  @Prop({ required: false, default: 16 }) iSize!: number;
  @Prop({ required: false, default: "#6f6f6f" }) iColor!: string;
  @Prop({ required: false, default: false }) isActive!: boolean;
  @Prop({ required: false, default: "button" }) type!: "button" | "submit" | "reset";
  get variantCop(): string {
    let returnTemp: string = this.variant + "_PButton";
    if (this.isActive) {
      returnTemp = returnTemp + " active_PButton";
    }
    return returnTemp;
  }
  get giveMeClassDisabled(): string {
    if (this.disabled) {
      return "disabled_PButton";
    } else {
      return "";
    }
  }
  get classMarginIcon(): string {
    if (this.icon) {
      return "marginIconTex_PButton";
    } else {
      return "";
    }
  }
  click(): void {
    if (!this.disabled) {
      this.$emit("click");
    }
  }
}
export default PButton;
</script>
<style lang="scss" scoped>
.marginIconTex_PButton {
  margin-left: 0.5rem;
}

.primary_PButton,
.circle_PButton,
.secondary_PButton,
.transparent_PButton {
  cursor: pointer;
  -o-object-fit: contain;
  object-fit: contain;
  border-radius: 24.5px;
  font-family: Roboto, Arial, Helvetica, sans-serif;
  font-size: 14px;
  font-weight: 500;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 0.5rem;
  margin-right: 0.5rem;
  white-space: nowrap;

  .b-icon.bi {
    vertical-align: top;
  }
}

.primary_PButton,
.secondary_PButton,
.transparent_PButton {
  min-width: 123px;
  width: max-content;
  padding: 8px 20px;
}

.primary_PButton,
.circle_PButton {
  background-color: var(--amarillo-prosegur);
  border: solid 1px var(--amarillo-prosegur);
  color: var(--secundario-prosegur-oscuro);

  &:hover,
  &:active,
  &:focus {
    background-color: var(--amarillo-prosegur-plus-60);
    border: solid 1px var(--amarillo-prosegur-plus-60);
  }
}

.secondary_PButton {
  background-color: var(--blanco-prosegur);
  border: solid 1px var(--amarillo-prosegur);
  color: var(--secundario-prosegur-oscuro);

  &:hover,
  &:active,
  &:focus {
    border-color: var(--amarillo-prosegur-plus-60);
  }
}

.transparent_PButton {
  background-color: transparent;
  border: solid 1px var(--amarillo-prosegur);
  color: var(--amarillo-prosegur);

  &:hover,
  &:active,
  &:focus {
    border-color: var(--amarillo-prosegur-plus-60);
    color: var(--amarillo-prosegur-plus-60);
  }
}

.icon_PButton {
  margin-top: -2px;
}

.p-button-action-table {
  background-color: rgba(255, 209, 2, 0.1);
  border: none;
}

.gray-circle_PButton,
.circle_PButton {
  border-radius: 100%;
  height: 40px;
  width: 40px;
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.link_PButton {
  height: 40px;
  object-fit: contain;
  border-radius: 24.5px;
  background-color: transparent;
  font-family: Roboto, Arial, Helvetica, sans-serif;
  font-size: 12px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  border: none;
  color: var(--amarillo-alternativo);
  padding: 6px 0;
  white-space: nowrap;
}

.gray_PButton {
  object-fit: contain;
  border-radius: 16px;
  border: solid 1px #e8e8e8;
  background-color: #fff;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: normal;
  color: #6f6f6f;
  padding: 6px 12px;
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  white-space: nowrap;
  margin-left: 10px;
  height: 32px;
}

.gray_PButton .material-icons {
  font-size: 1.2rem;
  color: #6f6f6f;
}

.gray_PButton .textButton {
  padding-left: 8px;
}

.gray-circle_PButton {
  display: flex;
  border-radius: 100%;
  border: solid 1px #e8e8e8;
  background-color: #fff;
  color: #6f6f6f;
  align-items: center;
  justify-content: center;
  margin-left: 10px;
}

.gray-circle_PButton.material-icons {
  color: #6f6f6f;
}

.active_PButton {
  border: solid 1px #d7b000;
}

.disabled_PButton {
  opacity: 0.5;
  cursor: not-allowed;
}
</style>
